module.exports = __webpack_public_path__ + "static/media/BSDA.d321a011.png";